import LoadBatch from "../core/LoadBatch";
import F84Game from "../Game";
import LoaderScene from "../scenes/LoaderScene";
import { Tileset } from "../utils/TiledMap";

export default class LoadBatches {
	static get GlobalSounds(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("global-sounds");
		if (batch.assets.size == 0) {
			batch.addSounds("./assets/audio/music/", {
				gameMusic: "flurry-music_1",
			});

			batch.addSounds("./assets/audio/sfx/", {
				buttonPress: "ag-ui-button_1_1",
				gameCompleteSFX: "flurry-game-complete",
			});
		}
		return batch;
	}

	static get Transition(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("screen-transition");
		// const quality = F84Game.Instance.qualitySuffix;
		if (batch.assets.size == 0) {
			//
		}
		return batch;
	}

	//==========================// Global Assets //==========================//
	static get Global(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("global");
		if (batch.assets.size == 0) {
			batch.addImages("./assets/images/temp/", {
				popupContainer: "popup-container",
			});

			batch.addImages("./assets/images/ui/popups/ag-lumi-ui-", {
				checkBtn: "btn-check",
				xBtn: "btn-x",
				closeBtn: "btn-close",
				popupSmallBacker: "popup-smallbacker",
				popupMiniHeader: "popup-smallheader",
				popupTextBacker: "popup-textback",
			});

			batch.addImages("./assets/images/ui/recap/ag-lumi-ui-", {
				popupBacker: "popup-backer",
				popupOverlay: "popup-overlay",
				popupHeader: "popup-header",
			});

			batch.addImages("./assets/images/ui/story/ag-lumi-", {
				storyBacker: "ui-help-largebacker",
				storyTextBacker: "hog-help-largetextbacker",
			});

			batch.addImages("./assets/images/ui/recap/ag-lumi-ui-", {
				nextBtn: "btn-next",
			});

			// Confirm quit popup
			batch.addImages("./assets/images/ui/popups/ag-lumi-ui-", {
				resumeBtn: "btn-resume",
				helpBtn: "btn-help",
				homeBtn: "btn-home",
				soundBtnOff: "btn-sound-off",
				soundBtnOn: "btn-sound-on",
			});

			batch.addImages("./assets/images/particles/ag-lumi-", {
				fallingSnow1: "fallingsnow1",
				fallingSnow2: "fallingsnow2",
				fallingSnow3: "fallingsnow3",
			});

			batch.addImages("./assets/images/ui/recap/ag-lumi-ui-", {
				popupMedalGOLD: "popup-medal-gold",
				popupMedalSILVER: "popup-medal-silver",
				popupMedalBRONZE: "popup-medal-bronze",
			});
		}
		return batch;
	}

	//==========================// Menu Assets //==========================//
	static get Menu(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("menu");
		if (batch.assets.size == 0) {
			// Story
			batch.addImages("./assets/images/ui/story/ag-lumi-", {
				storyImg1: "hog-story-img1",
				storyImg2: "hog-story-img2",
				storyImg3: "hog-story-img3",
				dayCompleteImg: "hog-complete-image-day",
				nightCompleteImg: "hog-complete-image-night",
				skipBtn: "ui-btn-skip",
				downloadBtn: "complete-btn-download",
				homeCompleteBtn: "complete-btn-home",
				certificate: "hog-certificate",
				leftDeco: "hog-complete-decoleft",
				rightDeco: "hog-complete-decoright",
				certificateBacker: "complete-cert-backer",
				certificateBg: "complete-bg",
				certificateHeader: "complete-header",
				certificateStars: "complete-stars",
				certificateTextBacker: "complete-textback",
			});

			batch.addImages("./assets/images/ui/level-select/ag-lumi-", {
				level1Day: "hoj-lvl1-day",
				level2Day: "hoj-lvl2-day",
				level3Day: "hoj-lvl3-day",
				level4Day: "hoj-lvl4-day",
				level1Night: "hoj-lvl1-night",
				level2Night: "hoj-lvl2-night",
				level3Night: "hoj-lvl3-night",
				level4Night: "hoj-lvl4-night",
				levelSelectBG: "hoj-lvl-bg",
				levelLocked: "hoj-lvl-locked",
				dayNightButtonDown: "lvl-btn-daynight-down",
				dayNightButtonUp: "lvl-btn-daynight-up",
				levelHeader: "lvl-header",
				lockIcon: "lvl-lock",
				medalIconGOLD: "lvl-medal-gold",
				medalIconSILVER: "lvl-medal-silver",
				medalIconBRONZE: "lvl-medal-bronze",
				medalIconNone: "lvl-empty-medal",
				numberBase: "lvl-numberbase",
				numberBaseGreen: "lvl-numberbase-green",
				backButton: "ui-btn-back",
				day: "ui-recap-day",
				night: "ui-recap-night",
				certificateButton: "ui-btn-certificates",
			});
		}
		return batch;
	}

	//==========================// Load level specific items //==========================//
	static level(levelIndex: number): LoadBatch {
		let dayNight = "day";
		if (levelIndex >= 4) {
			levelIndex -= 4;
			dayNight = "night";
		}
		const batch = F84Game.Instance.loadBatches.get("level" + (levelIndex + 1) + dayNight);
		if (batch.assets.size == 0) {
			let dayNightDif = 2;
			if (dayNight == "day") dayNightDif = 1;

			const i = dayNightDif + 2 * levelIndex;

			batch.addImages("./assets/images/game/environments/", {
				["lumi-hog-bg" + i + "-1.png"]: "lumi-hog-bg" + i + "-1",
				["lumi-hog-bg" + i + "-2.png"]: "lumi-hog-bg" + i + "-2",
				["lumi-hog-bg" + i + "-3.png"]: "lumi-hog-bg" + i + "-3",
			});

			if (i != 7 && i != 8) {
				batch.addImages("./assets/images/game/environments/", {
					["lumi-hog-bg" + i + "-4.png"]: "lumi-hog-bg" + i + "-4",
				});
			}
		}
		return batch;
	}

	//==========================// Standard Gameplay Assets //==========================//
	static Gameplay(scene: LoaderScene): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("gameplay");
		if (batch.assets.size == 0) {
			// Todo: This should be restructured so we only load the tileset and level assets we need for the level we are accessing
			const tileset = scene.cache.json.get("flurry-tileset") as Tileset;
			this.loadTilesetImages(batch, tileset, "./assets/images/game/objects/");

			batch.addImages("./assets/images/ui/gameplay/ag-lumi-ui-", {
				// Objects
				backpack1: "obj-backpack1",
				backpack2: "obj-backpack2",
				beanie1: "obj-beanie1",
				beanie2: "obj-beanie2",
				bear1: "obj-bear1",
				bear2: "obj-bear2",
				boot1: "obj-boot1",
				boot2: "obj-boot2",
				compass1: "obj-compass1",
				compass2: "obj-compass2",
				// it's hidden object is named mountainlion
				mountainlion1: "obj-cougar1",
				mountainlion2: "obj-cougar2",
				deer1: "obj-deer1",
				deer2: "obj-deer2",
				dogs1: "obj-dogs1",
				dogs2: "obj-dogs2",
				dogtoy1: "obj-dogtoy1",
				dogtoy2: "obj-dogtoy2",
				duck1: "obj-duck1",
				duck2: "obj-duck2",
				fox1: "obj-fox1",
				fox2: "obj-fox2",
				mountaingoat1: "obj-goat1",
				mountaingoat2: "obj-goat2",
				map1: "obj-map1",
				map2: "obj-map2",
				marmot1: "obj-marmot1",
				marmot2: "obj-marmot2",
				mitten1: "obj-mitten1",
				mitten2: "obj-mitten2",
				mug1: "obj-mug1",
				mug2: "obj-mug2",
				oar1: "obj-oar1",
				oar2: "obj-oar2",
				owl1: "obj-owl1",
				owl2: "obj-owl2",
				pika1: "obj-pika1",
				pika2: "obj-pika2",
				skipole1: "obj-skipole1",
				skipole2: "obj-skipole2",
				snake1: "obj-snake1",
				snake2: "obj-snake2",
				soccerball1: "obj-soccerball1",
				soccerball2: "obj-soccerball2",
				tacklebox1: "obj-tacklebox1",
				tacklebox2: "obj-tacklebox2",
				thermos1: "obj-thermos1",
				thermos2: "obj-thermos2",

				// Other UI
				pauseButton: "btn-pause",
				objectBar: "objectbar",
				objectBarDog: "objectbar-dog",
				objectBarDogBacker: "objectbar-dogbacker",
				objectBarEmpty: "objectbar-empty",
				objectBarFull: "objectbar-full",
				objectBarRays: "objectbar-rays",
				objectBarRaysGlow: "objectbar-rays-glow",
				scoreBackground: "score",
				sparkle1: "sparkle1",
				sparkle2: "sparkle2",
				sparkle3: "sparkle3",
				timerBackground: "time",
				widescreenBorder: "widescreen-border",
			});

			batch.addImages("./assets/images/game/ag-lumi-gp-", {
				scoreRays: "points-burstrays",
				pointParticle1: "points-particle-1",
				pointParticle2: "points-particle-2",
			});

			// Help assets
			batch.addImages("./assets/images/ui/help/ag-lumi-", {
				helpImg1: "hog-help-img1",
				helpImg2: "hog-help-img2",
				helpImg3: "hog-help-img3",
				helpNumberBase: "help-numberbase",
			});

			// Recap assets
			batch.addImages("./assets/images/ui/recap/ag-lumi-ui-", {
				replayBtn: "btn-replay",
				popupBluePill: "popup-bluepill",
				popupNewBest: "popup-newbest",
				popupRays: "popup-rays",
				popupRaysGlow: "popup-raysglow",
				popupScore: "popup-score",
				popupSmallHeader: "popup-smallheader",
				recapDay: "recap-day",
				recapFlurry: "recap-flurry",
				recapNight: "recap-night",
				recapObjs: "recap-objs",
				recapTime: "recap-time",
			});

			batch.addImages("./assets/images/temp/", {
				pauseBtn: "pause-btn",
				overlay: "overlay",
				successIcon: "icon-success",
				tutHand: "tut-hand",
			});

			batch.addSounds("./assets/audio/sfx/", {
				objectFoundSFX: "flurry-object-found",
				objectNotFoundSFX: "flurry-object-not-found",
				trainingCompleteSFX: "flurry-training-complete",
			});
		}
		return batch;
	}

	static loadTilesetImages(batch: LoadBatch, tileset: Tileset, path: string): void {
		for (const tile of tileset.tiles) {
			const split = tile.image.split("/");
			const filename = split[split.length - 1];
			batch.addImage(filename, path + filename);
		}
	}
}
